export default __webpack_public_path__ + "static/media/live-series-hero.9a899633.png";